import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as Service from '../services';
import makeData from '../services/makeData';
import { GENERAL } from '../config/Transaction/ProductGeneralConf';


import { COLUMNS } from '../config/Transaction/columns';
import { addAfterLoginNotification } from '../../../components/Toast/utils/notifications';

interface AsyncState {
  isLoading: {
    productData: boolean;
    categoryData: boolean;
    brandsData: boolean;
    tagsData: boolean;
    productAdd: boolean;
    deleteProduct: boolean;
  };
  isSuccess: boolean;
  isError: boolean;
}

interface TableState extends AsyncState {
  productData: any;
  totalCount: Number;
  statusData: any;
  applicationOptions: any;
  addProductRes: any;
  editProductRes: any;
  deleteProductRes: any;
  isLogout: any;
  fullResponse: Array<any>;
  categoryData: Array<any>;
  brandsData: Array<any>;
  tagsData: Array<any>;
  rootReducer?: any;
  auth?: any;
  errorMsg?: any;
  userTableColumns: any,

}

const initialState: TableState = {
  isLoading: {
    productData: true,
    categoryData: true,
    brandsData: true,
    tagsData: true,
    productAdd: false,
    deleteProduct: false,
  },
  isSuccess: false,
  isError: false,
  productData: null,
  statusData: null,
  applicationOptions: null,
  addProductRes: null,
  editProductRes: null,
  deleteProductRes: null,
  totalCount: NaN,
  isLogout: false,
  fullResponse: [],
  categoryData: [],
  brandsData: [],
  tagsData: [],
  errorMsg: null,
  userTableColumns: COLUMNS,
};

const productDetails = {
  start_page: GENERAL.startPage,
  limit: GENERAL.itemsperpage,
  search: '',
  type: null,
  category: null,
  brand: null,
  rates: [],
  tags: [],
  // price: { range: [GENERAL.priceMin, GENERAL.priceMax] },
  sort: 'none',
};



export const fetchAllProducts = createAsyncThunk('productData', async (data: any, thunkAPI) => {
  try {
    const res: any = await Service.getAllProducts({
      ...productDetails,
      ...data,
    });

    console.log('res', res)

    const madeData = makeData(res.data);

    return { madeData, totalCount: res.totalCounts, fullResponse: res.data };
  } catch (error: any) {
    // thunkAPI.dispatch(resetLogout(error))
    return thunkAPI.rejectWithValue(error);
  }
});


export const addProduct = createAsyncThunk('user/addProductData', async (data: any, thunkAPI) => {
  try {
    return await Service.addProduct(data);
  } catch (error) {
    // thunkAPI.dispatch(resetLogout(error));
    return thunkAPI.rejectWithValue(error);
  }
});

export const deleteProduct = createAsyncThunk('user/deleteProduct', async (data: any, thunkAPI) => {
  try {
    return await Service.deleteProduct(data);
  } catch (error) {
    // thunkAPI.dispatch(resetLogout(error));
    return thunkAPI.rejectWithValue(error);
  }
});


export const getColumns = createAsyncThunk('getColumns', (data: any, thunkAPI) => {
  try {
    // const madeColsData = makeData(data);
    return data?.cols;
  } catch (error) {
    // thunkAPI.dispatch(resetLogout(error));
    return thunkAPI.rejectWithValue(error);
  }
});

export const categoryAsyncThunk = createAsyncThunk(
  "categories",
  async (data, thunkAPI) => {
    try {
      return await Service.getCatogories(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const brandsAsyncThunk = createAsyncThunk(
  "brands",
  async (data, thunkAPI) => {
    try {
      return await Service.getBrands(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const tagsAsyncThunk = createAsyncThunk(
  "tags",
  async (data, thunkAPI) => {
    try {
      return await Service.getTags(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);


export const productSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    resetAddProductRes: (state) => {
      state.addProductRes = {};
    }
  },
  extraReducers: (builder) => {
    builder
      //Obtaining data
      .addCase(fetchAllProducts.pending, (state, action: any) => {
        state.isLoading.productData = true;
        state.isError = false;
        state.errorMsg = null;
      })
      .addCase(fetchAllProducts.fulfilled, (state, action: any) => {
        console.log('action.payload', action.payload)
        state.isLoading.productData = false;
        state.isSuccess = true;
        state.isError = false;
        state.productData = action.payload.madeData;
        state.totalCount = action.payload.totalCount;
        state.fullResponse = action.payload.fullResponse;
        state.errorMsg = null;
      })
      .addCase(fetchAllProducts.rejected, (state, action: any) => {
        state.isLoading.productData = false;
        state.isError = true;
        state.errorMsg = action.payload.errorMsg;
        state = {
          ...state,
          ...action.payload
        }

      })

      .addCase(addProduct.pending, (state) => {
        state.isLoading.productAdd = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMsg = null;
        state.addProductRes = null;
      })
      .addCase(addProduct.fulfilled, (state, action: any) => {
        addAfterLoginNotification("Product Create successfully", "success");
        state.isLoading.productAdd = false;
        state.isSuccess = true;
        state.isError = false;
        state.addProductRes = action.payload;
      })
      .addCase(addProduct.rejected, (state, action: any) => {
        addAfterLoginNotification(action.payload.errorMsg, "error");
        state.isLoading.productAdd = false;
        state.isSuccess = false;
        state.isError = true;
        state.addProductRes = null;
        state.errorMsg = action.payload.errorMsg;
      })


      // MODIFY_COLUMNS
      .addCase(getColumns.pending, (state) => {
        // state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.userTableColumns = initialState.userTableColumns;
      })
      .addCase(getColumns.fulfilled, (state, action: any) => {
        // state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.userTableColumns = action.payload;
      })
      .addCase(getColumns.rejected, (state) => {
        // state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.userTableColumns = initialState.userTableColumns;
      })

      .addCase(categoryAsyncThunk.pending, (state) => {
        state.isLoading.categoryData = true;
        state.isError = false;
        state.isSuccess = false;
        state.categoryData = [];
      })
      .addCase(categoryAsyncThunk.fulfilled, (state, action) => {
        state.isLoading.categoryData = false;
        state.isSuccess = true;
        state.isError = false;
        state.categoryData = action.payload.data;
      })
      .addCase(categoryAsyncThunk.rejected, (state, action) => {
        state.isLoading.categoryData = false;
        state.isError = true;
        state.isSuccess = false;
        state.categoryData = [];
      })

      .addCase(brandsAsyncThunk.pending, (state) => {
        state.isLoading.brandsData = true;
        state.isError = false;
        state.isSuccess = false;
        state.brandsData = [];
      })
      .addCase(brandsAsyncThunk.fulfilled, (state, action) => {
        state.isLoading.brandsData = false;
        state.isSuccess = true;
        state.isError = false;
        state.brandsData = action.payload.data;
      })
      .addCase(brandsAsyncThunk.rejected, (state, action) => {
        state.isLoading.brandsData = false;
        state.isError = true;
        state.isSuccess = false;
        state.brandsData = [];
      })

      .addCase(tagsAsyncThunk.pending, (state) => {
        state.isLoading.tagsData = true;
        state.isError = false;
        state.isSuccess = false;
        state.tagsData = [];
      })
      .addCase(tagsAsyncThunk.fulfilled, (state, action) => {
        state.isLoading.tagsData = false;
        state.isSuccess = true;
        state.isError = false;
        state.tagsData = action.payload.data;
      })
      .addCase(tagsAsyncThunk.rejected, (state, action) => {
        state.isLoading.tagsData = false;
        state.isError = true;
        state.isSuccess = false;
        state.tagsData = [];
      })

      .addCase(deleteProduct.pending, (state) => {
        state.isLoading.deleteProduct = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMsg = null;
        state.deleteProductRes = null;
      })
      .addCase(deleteProduct.fulfilled, (state, action: any) => {
        addAfterLoginNotification('Product Deleted successfully', "success");
        state.isLoading.deleteProduct = false;
        state.isSuccess = true;
        state.isError = false;
        state.deleteProductRes = action.payload;
      })
      .addCase(deleteProduct.rejected, (state, action: any) => {
        addAfterLoginNotification(action.payload.errorMsg, "error");
        state.isLoading.deleteProduct = false;
        state.isSuccess = false;
        state.isError = true;
        state.deleteProductRes = null;
        state.errorMsg = action.payload.errorMsg;
      })


  },
});
export const {resetAddProductRes} = productSlice.actions;
export default productSlice.reducer;
